import {
  Flex,
  Heading,
  Image,
  Link,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useSearchParams } from "react-router";

import { NavButton } from "@/components/nav-button";

export const NotFound = () => {
  const [searchParams] = useSearchParams();

  const errorMessage = searchParams.get("error");

  return (
    <VStack
      gap={8}
      px={4}
      h="100vh"
      justifyContent="center"
      maxW="620px"
      mx="auto"
    >
      <Stack
        gap={[6, 6, 12]}
        justifyContent="center"
        alignItems="center"
        flexDirection={["column", "column", "row"]}
      >
        <Image src="/assets/error.avif" w="181px" h="158px" />
        <VStack
          alignItems="flex-start"
          textAlign={["center", "center", "left"]}
        >
          <Heading fontSize="3xl" fontWeight="bold" mx={["auto", "auto", 0]}>
            Error
          </Heading>
          <Heading fontSize="2xl" fontWeight="500" color="text.secondary">
            If this problem persists, please reach out to us on{" "}
            <Link
              href="https://t.me/plumenetwork_community"
              target="_blank"
              color="fg"
            >
              Telegram
            </Link>{" "}
            or{" "}
            <Link
              href="https://discord.com/invite/plume-network"
              target="_blank"
              color="fg"
            >
              Discord
            </Link>
          </Heading>
          <NavButton
            href="/"
            variant="solid"
            mt={4}
            w={["full", "full", "auto"]}
          >
            Back to Homepage
          </NavButton>
        </VStack>
      </Stack>
      {errorMessage && (
        <Flex p={6} bg="bg.subtle" w="full" rounded="16px" gap={2.5}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M22.201 17.6335L14.0026 3.39569C13.7977 3.04687 13.5052 2.75764 13.1541 2.55668C12.803 2.35572 12.4055 2.25 12.001 2.25C11.5965 2.25 11.199 2.35572 10.8479 2.55668C10.4968 2.75764 10.2043 3.04687 9.99944 3.39569L1.80101 17.6335C1.60388 17.9709 1.5 18.3546 1.5 18.7454C1.5 19.1361 1.60388 19.5199 1.80101 19.8572C2.00325 20.2082 2.29523 20.499 2.64697 20.6998C2.99871 20.9006 3.39755 21.0043 3.80257 21.0001H20.1994C20.6041 21.0039 21.0026 20.9001 21.354 20.6993C21.7054 20.4985 21.997 20.2079 22.1991 19.8572C22.3965 19.52 22.5007 19.1364 22.5011 18.7456C22.5014 18.3549 22.3978 17.9711 22.201 17.6335ZM11.251 9.75006C11.251 9.55115 11.33 9.36038 11.4707 9.21973C11.6113 9.07908 11.8021 9.00006 12.001 9.00006C12.1999 9.00006 12.3907 9.07908 12.5313 9.21973C12.672 9.36038 12.751 9.55115 12.751 9.75006V13.5001C12.751 13.699 12.672 13.8897 12.5313 14.0304C12.3907 14.171 12.1999 14.2501 12.001 14.2501C11.8021 14.2501 11.6113 14.171 11.4707 14.0304C11.33 13.8897 11.251 13.699 11.251 13.5001V9.75006ZM12.001 18.0001C11.7785 18.0001 11.561 17.9341 11.376 17.8105C11.191 17.6868 11.0468 17.5111 10.9616 17.3056C10.8765 17.1 10.8542 16.8738 10.8976 16.6556C10.941 16.4374 11.0482 16.2369 11.2055 16.0796C11.3628 15.9222 11.5633 15.8151 11.7815 15.7717C11.9998 15.7283 12.226 15.7505 12.4315 15.8357C12.6371 15.9208 12.8128 16.065 12.9364 16.25C13.06 16.4351 13.126 16.6526 13.126 16.8751C13.126 17.1734 13.0075 17.4596 12.7965 17.6706C12.5855 17.8815 12.2994 18.0001 12.001 18.0001Z"
              fill="#747474"
            />
          </svg>
          <Text fontWeight="500" color="text.secondary">
            {errorMessage}
          </Text>
        </Flex>
      )}
    </VStack>
  );
};
